import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Table = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="table">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.3999 5.9999C1.3999 3.45939 3.45939 1.3999 5.9999 1.3999H17.9999C20.5404 1.3999 22.5999 3.45939 22.5999 5.9999V17.9999C22.5999 20.5404 20.5404 22.5999 17.9999 22.5999H5.9999C3.45939 22.5999 1.3999 20.5404 1.3999 17.9999V5.9999ZM9.9999 20.5999H17.9999C19.4358 20.5999 20.5999 19.4358 20.5999 17.9999V9.9999H9.9999V20.5999ZM7.9999 9.9999V20.5999H5.9999C4.56396 20.5999 3.3999 19.4358 3.3999 17.9999V9.9999H7.9999ZM9.9999 7.9999H20.5999V5.9999C20.5999 4.56396 19.4358 3.3999 17.9999 3.3999H9.9999V7.9999ZM7.9999 3.3999V7.9999H3.3999V5.9999C3.3999 4.56396 4.56396 3.3999 5.9999 3.3999H7.9999Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
